<mat-toolbar color="primary">
    <span>Device Sync</span>
</mat-toolbar>
<div class="main-container">
    <div>
        <span>This device has not the LUT (Look Up Table), you need to synchronize the device following next steps: </span>
    </div>
    <div class="container">
        <div class="step-one">
            <div><span>1. Click on "Sync Device" </span></div>
            <div class="img-container">
                <img src="/assets/images/lut-file-instructions/step1.jpg" alt="">
            </div>
        </div>
        <div class="step-two">
            <div><span>2. Sync with extended services</span></div>
            <div class="img-container">
                <img src="/assets/images/lut-file-instructions/step2.jpg" alt="">
            </div>
        </div>
    </div>
    <div class="actions-container">
        <span>Once you have successfully synchronize the device, please click the next button </span>
        <button mat-raised-button data-testid="ic-syncdevice-validate-button" (click)="validateLUT()" color="primary">VALIDATE LUT</button>
        <div class="message-container" *ngIf="status === true">
            <mat-icon class="success">check_circle</mat-icon>
            <span>LUT in the cloud</span>
        </div>
        <div class="message-container" *ngIf="status === false">
            <mat-icon class="error">cancel</mat-icon>
            <span>LUT NOT FOUND IN THE CLOUD</span>
        </div>
    </div>
    <div class="close-container">
        <button mat-raised-button data-testid="ic-syncdevice-close-button" (click)="closeDialog()">Close</button>
    </div>
</div>